<cv-add-button [title]="newButtonLabel" (clickEvent)="onAddDataMessageType()"></cv-add-button>

<div class="datatable-content scrollable-component">
	<ag-grid-angular
		#grid
		class="ag-theme-balham"
		(gridReady)="onInitializeGrid($event)"
		(gridSizeChanged)="resizeToFitColumns()"
		[pagination]="false"
		[suppressPaginationPanel]="true"
		[gridOptions]="gridOptions"
		[domLayout]="'autoHeight'"
		[rowData]="gridData"
	>
	</ag-grid-angular>
</div>
